import React, { useEffect, useState } from "react";
import SearchableSelect from "components/common/searchableSelect/SearchableSelect";
import TextField from "common/TextField";
import { useTranslation } from "react-i18next";
const Step1 = ({
  formik,
  bGId,
  branchList = [],
  bankList = [],
  handleNext,
  handleError,
  handleCompletion,
  handleSelectedBank,
}) => {
  const { t } = useTranslation();
  const STEP_ID = 1;
  const { location, branchName, bankId, bankGroupId } = formik.values;

  let [disabled, setDisabled] = useState(() =>
    location.length > 0 &&
    branchName.length > 0 &&
    bankId.length > 10 &&
    bankGroupId.length > 10
      ? false
      : true
  );

  useEffect(() => {
    setDisabled(
      location.length > 0 &&
        branchName.length > 0 &&
        bankId.length > 10 &&
        bankGroupId.length > 10
        ? false
        : true
    );
  }, [location, branchName, bankId, bankGroupId]);

  useEffect(() => {
    if (!disabled) {
      handleError(STEP_ID, false);
      handleCompletion(STEP_ID, true);
    } else if (disabled) {
      handleError(STEP_ID, true);
      handleCompletion(STEP_ID, false);
    }
  }, [disabled]);

  useEffect(() => {
    const { branchId = "", location = "", bankName = "" } = branchList[0] || {};
    formik.setFieldValue("branchName", bankName);
    formik.setFieldValue("location", location);
  }, [branchList, bankId]);

  return (
    <div className="d-flex flex-column justify-content-between h-100">
      <h6>{t("bank-information")}</h6>
      <div className=" mt-2">
        <SearchableSelect
          placeholder="Select Bank Group"
          name="bankGroupId"
          handleChange={(key, value) => formik.setFieldValue(key, value)}
          value={formik.values.bankGroupId}
          options={[
            { disabled: true, value: bGId, label: "Genossenschaftsbanken" },
          ]}
          errors={
            formik.values.bankGroupId.length > 10 && formik.errors.bankGroupId
          }
          isDisabled={true}
          defaultValue="Genossenschaftsbanken"
          minWidth={"calc(100%-0.4rem)"}
        />
      </div>
      <div className=" mt-2">
        <SearchableSelect
          placeholder={t("select-bank")}
          name="bankId"
          handleChange={(key, value, rest) => {
            let { label = "" } = rest || {};
            handleSelectedBank(label);
            formik.setFieldValue(key, value);
          }}
          value={formik.values.bankId}
          options={bankList?.map((el) => {
            return { value: el.bankId, label: el.bankName };
          })}
          errors={formik.values.bankId.length > 10 && formik.errors.bankId}
          minWidth={"calc(100%-0.4rem)"}
        />
      </div>
      <h6 className="mt-2">{t("branch-information")}</h6>
      <div className="inputField mt-2">
        <SearchableSelect
          placeholder={t("select-branch")}
          name="branchName"
          handleChange={(key, value, rest) => {
            let { branchLocation = "", label = "" } = rest || {};
            formik.setFieldValue(key, label);
            formik.setFieldValue("location", branchLocation);
          }}
          value={formik.values.branchName}
          options={branchList?.map((el) => {
            return {
              ...el,
              value: el.bankName,
              label: el.bankName,
            };
          })}
          errors={
            formik.values.branchName.length > 10 && formik.errors.branchName
          }
          minWidth={"calc(100%-0.4rem)"}
        />
      </div>
      <div className="inputField  mt-2">
        <TextField
          isDisabled={true}
          type="text"
          className="form-control"
          placeholder={t("location")}
          name="location"
          onChange={formik.handleChange}
          value={formik.values.location}
          error={formik.touched.location && formik.errors.location}
        />
      </div>
      <div className="d-flex justify-content-end align-items-center mt-5">
        <button
          className="parentbtn "
          onClick={handleNext}
          style={{
            padding: "10px 35px",
            ...(disabled && { filter: "  opacity(30%)" }),
          }}
          disabled={disabled}
        >
          {t("next")}
        </button>
      </div>
    </div>
  );
};

export default Step1;
